<template>
  <div class="tw-relative tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-screen tw-px-4" style="font-family: 'Kanit', system-ui, -apple-system, sans-serif;">
    <QImg src="/images/error.webp" alt="error" class="tw-w-1/2 -tw-mt-20 -tw-ml-5" />
    <div class="tw-text-center tw-title-01 tw-mt-4">{{ $t('serverDown.title') }}</div>
    <div class="tw-text-center tw-body-01 tw-mt-2 tw-text-gray-500 tw-max-w-md">{{ $t('serverDown.description') }}</div>
  </div>
</template>

<script setup lang="ts">
useHead({
  link: [
    { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
    { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: 'anonymous' },
    { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Kanit:wght@400;500;600;700&display=swap' },
  ],
})
</script>
